import { FaCheckCircle, FaHome, FaArrowRight } from "react-icons/fa";

const DemoExamFinished = ({ examId, userId }) => {
  const goHome = () => {
    window.location.href = 'https://examinax.com/';
  };

  return (
    <div className="flex justify-center items-center min-h-screen" style={{ backgroundColor: 'var(--background-color)', zIndex: 9999 }}>
      <div className="w-4/5 max-w-2xl bg-var(--background-color) border border-var(--border-color) rounded-2xl p-12 text-center relative overflow-hidden shadow-2xl">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-2 bg-[#FC532B]"></div>
        <div className="absolute top-4 right-4 w-16 h-16 bg-[#FC532B] rounded-full opacity-20"></div>
        <div className="absolute bottom-4 left-4 w-12 h-12 bg-[#FC532B] rounded-full opacity-15"></div>
        
        {/* Success Icon */}
        <div className="mb-8">
          <div className="w-24 h-24 bg-[#FC532B] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
            <FaCheckCircle className="text-white text-4xl" />
          </div>
        </div>

        {/* Content */}
        <div>
          <h2 className="text-4xl font-bold text-var(--text-color) mb-4">Demo Exam Completed!</h2>
          <p className="text-lg text-var(--text-color) opacity-80 mb-8 leading-relaxed">
            Excellent! You've successfully completed the demo exam. 
            Experience the full features and get ready for your actual IELTS preparation.
          </p>

          {/* Action Button */}
          <button 
            onClick={goHome}
            className="bg-[#FC532B] hover:bg-[#e04a26] text-white font-bold px-8 py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center mx-auto text-lg group"
          >
            <FaHome className="mr-3 group-hover:rotate-12 transition-transform" />
            Return to Home
            <FaArrowRight className="ml-3 group-hover:translate-x-1 transition-transform" />
          </button>

          {/* Additional Info */}
          <div className="mt-8 p-4 bg-var(--background-color) border border-var(--border-color) rounded-lg">
            <p className="text-sm text-var(--text-color) opacity-70">
              Ready to start your real IELTS preparation journey? Explore our full range of practice materials.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoExamFinished;
